import { Select } from "antd";

import type { useGetLogFilterOptionsQuery } from "generated/graphql";

import type { FiltersProps } from "../../type";

import s from "./SelectFilter.module.css";

const { Option } = Select;

const SEARCH_CONFIG = { optionFilterProp: "value" };
const FILTER_FIELDS = ["name", "email", "section", "region"] as const;
type FilterField = (typeof FILTER_FIELDS)[number];

interface Props {
  field: FilterField;
  filterOptions: Record<
    FilterField,
    ReturnType<typeof useGetLogFilterOptionsQuery>
  >;
  filterOptionsKey?: FilterField;
  handleChange: (key: keyof FiltersProps, value: any) => void;
  id: string;
  label: string;
  placeholder?: string;
  value: string | null;
}

export const SelectFilter = ({
  id,
  label,
  field,
  value,
  handleChange,
  filterOptions,
  filterOptionsKey = field,
  placeholder,
}: Props) => {
  const { data, loading } = filterOptions[filterOptionsKey];
  const options = data?.auditLogLookups?.items ?? [];

  return (
    <div className={s.field}>
      <label htmlFor={id}>{label}</label>
      <Select
        id={id}
        placeholder={placeholder ?? label}
        showSearch={SEARCH_CONFIG}
        allowClear
        value={value || undefined}
        onChange={val => handleChange(field, val ?? null)}
        loading={loading}
      >
        {options.map(opt => (
          <Option key={opt.value} value={opt.value}>
            {opt.value}
          </Option>
        ))}
      </Select>
    </div>
  );
};
